<div class="container" fxLayout="column" fxLayoutAlign="space-between stretch" class="h-100">
  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" [matTooltip]="data.workflowState.description">
      <product-workflow-icon id="current-state-icon"
        [workflowStateType]="data.workflowState.stateType">
      </product-workflow-icon>
      <span class="current-state-name">
        {{ data.workflowState.name }}
      </span>
    </div>
    <span>Available Actions:</span>
    <div fxLayout="row" fxLayout="row wrap" fxFlexAlign="left" fxLayoutGap="10px grid">
      <div>
        <button fxFlex mat-stroked-button (click)="selectedTransition = undefined" matTooltip="Add a comment about the product.">
          <mat-icon *ngIf="selectedTransition !== undefined" class="change-state-icon">radio_button_unchecked</mat-icon>
          <mat-icon *ngIf="selectedTransition === undefined" class="change-state-icon">radio_button_checked</mat-icon>
          Add a Comment
        </button>
      </div>
      
      <ng-container *ngFor="let item of data.workflowState.transitions">
        <div>
          <button mat-stroked-button (click)="selectedTransition = item" [matTooltip]="item.triggerDescription">
            <mat-icon *ngIf="selectedTransition !== item" class="change-state-icon">radio_button_unchecked</mat-icon>
            <mat-icon *ngIf="selectedTransition === item" class="change-state-icon">radio_button_checked</mat-icon>
            {{ item.triggerName }}
          </button>
        </div>
      </ng-container>
      
      <ng-container *ngFor="let item of data.workflowState.restrictedTransitions">
        <div *ngIf="shouldShowTransition(item)">
          <button mat-stroked-button (click)="selectedTransition = item" [matTooltip]="item.triggerDescription">
            <mat-icon *ngIf="selectedTransition !== item" class="change-state-icon">radio_button_unchecked</mat-icon>
            <mat-icon *ngIf="selectedTransition === item" class="change-state-icon">radio_button_checked</mat-icon>
            {{ item.triggerName }}
          </button>
        </div>
      </ng-container>

    </div>
  </div>

  <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="5px">
    <div *ngIf="selectedTransition" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" [matTooltip]="data.workflowState.description">
        <product-workflow-icon id="transition-state-icon"
          [workflowStateType]="data.workflowState.stateType">
        </product-workflow-icon>
        <span class="transition-state-name">
          {{ data.workflowState.name }}
        </span>
      </div>

      <mat-icon class="next-state-icon">straight</mat-icon>

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" [matTooltip]="selectedTransition.destinationDescription">
        <product-workflow-icon id="transition-state-icon"
          [workflowStateType]="selectedTransition.destinationStateType">
        </product-workflow-icon>
        <span class="transition-state-name">
          {{ selectedTransition.destinationName }}
        </span>
      </div>

    </div>

    <mat-form-field class="example-full-width" appearance="fill">
      <mat-label>Add a comment</mat-label>
      <textarea matInput [(ngModel)]="comments" [required]="selectedTransition?.requiresWorkflowComments"></textarea>
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px" class="p-t-10">
      <div fxLayout="row" fxLayoutAlign="start center">
        <span class="invalid-reason-text" *ngIf="!triggerIsValid()">
          {{ triggerInvalidReason }}
        </span>
      </div>

      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
        <button type="button" mat-flat-button color="accent" (click)="onRunTrigger()" [disabled]="!triggerIsValid()" matTooltip="Run workflow transition">
          <mat-icon *ngIf="selectedTransition" class="next-state-icon">straight</mat-icon>
          <mat-icon *ngIf="!selectedTransition">comment</mat-icon>
          {{ selectedTransition?.triggerName ?? "Add Comment" }}
        </button>
  
        <button type="button" mat-stroked-button color="basic" (click)="nagivateBack()" matTooltip="Cancel workflow transition">
          <mat-icon>clear</mat-icon> Cancel
        </button>
      </div>
    </div>
  </div>
</div>